import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=fa192218&scoped=true"
import script from "./resetpwd.vue?vue&type=script&lang=js"
export * from "./resetpwd.vue?vue&type=script&lang=js"
import style0 from "./resetpwd.vue?vue&type=style&index=0&id=fa192218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa192218",
  null
  
)

export default component.exports